export default __webpack_public_path__ + "static/media/checkHover.36879770.png";